import { cn } from '@/lib/utils'
import { useTeamEventParticipantsContext } from '../context/TeamEventParticipantsContext'
import EventActivityIssuesBadge from './EventActivityIssuesBadge'

type Props = {
  activity: wowaudit.EventActivity
  hasLinkedPlanIssues: boolean
  linkedPlanIssueCount: number
  allEncounters?: boolean
}

const EventActivitySelectionCount = ({
  activity,
  hasLinkedPlanIssues,
  linkedPlanIssueCount,
  allEncounters,
}: Props) => {
  const { activityIssuesById } = useTeamEventParticipantsContext()
  const issues = activityIssuesById.get(activity.id)

  if (!activity.active) {
    return <div className='text-xs text-muted-foreground h-5'>inactive</div>
  }

  return (
    <div className='h-5 flex items-center justify-between gap-2'>
      <span className='text-sm font-mono flex items-center gap-0.5'>
        <span
          className={cn(
            issues?.tooManyPlayers
              ? 'text-warning-foreground'
              : issues?.selectedCount === activity.raidSize
              ? 'text-success-foreground'
              : 'text-foreground',
          )}
        >
          {issues?.selectedCount ?? 0}
        </span>
        <span className='text-muted-foreground'>/</span>
        <span>{activity.raidSize ?? '-'}</span>
      </span>
      <EventActivityIssuesBadge
        activityId={activity.id}
        hasLinkedPlanIssues={hasLinkedPlanIssues}
        linkedPlanIssueCount={linkedPlanIssueCount}
        allEncounters={allEncounters}
      />
    </div>
  )
}

export default EventActivitySelectionCount
